import { api } from "./api";

export const citiesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCities: builder.query({
      query: () => "api/Sys/Cities",
      providesTags: ["cities"],
    }),
    addCity: builder.mutation({
      query: (formData) => ({
        url: "api/Sys/Cities",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["cities"],
    }),
    editCity: builder.mutation({
      query: (formData) => ({
        url: "api/Sys/Cities",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["cities"],
    }),
    deleteCity: builder.mutation({
      query: (cityId) => ({
        url: `api/Sys/Cities?CityID=${cityId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["cities"],
    }),
  }),
});

export const {
  useGetCitiesQuery,
  useAddCityMutation,
  useEditCityMutation,
  useDeleteCityMutation,
} = citiesApi;
